import type { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { type BalanceCorrectionValues, balanceCorrectionSchema } from './correction.schema'

type Submit = ReturnType<UseFormReturn<BalanceCorrectionValues>['handleSubmit']>
type Props = Omit<UseFormProps<BalanceCorrectionValues>, 'resolver'> & {
  onSubmit: SubmitHandler<BalanceCorrectionValues>
  children: (form: UseFormReturn<BalanceCorrectionValues>, submit: Submit) => React.ReactNode
}

export const BalanceCorrectionForm = ({ onSubmit, children, ...options }: Props) => {
  const form = useFormWithSchema({ mode: 'all', ...options }, balanceCorrectionSchema)
  const submit = form.handleSubmit(onSubmit)
  return (
    <Form {...form}>
      <form onSubmit={submit}>{children(form, submit)}</form>
    </Form>
  )
}
